import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=3e1329f2&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./ProfileHeader.vue?vue&type=style&index=0&id=3e1329f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1329f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e1329f2')) {
      api.createRecord('3e1329f2', component.options)
    } else {
      api.reload('3e1329f2', component.options)
    }
    module.hot.accept("./ProfileHeader.vue?vue&type=template&id=3e1329f2&scoped=true", function () {
      api.rerender('3e1329f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/ProfileHeader.vue"
export default component.exports